var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "color",
    id: "Capa_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23 47",
    style: {
      enableBackground: "new 0 0 23 47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7,17.9h-2.6v-0.8c0.7,0,1.3,0,1.7,0c1.8,0,1.8-1.6,1.8-2.4c0-0.4,0-11.3,0-11.3c0-1.2-2.8-2.2-2.8-2.2S14.7,0,12,0 C8.9,0,8.7,0.6,8,1.2C6.4,1.7,5.3,3.1,5.3,3.7c0,0.3,0,10.4,0,11.3c0,1.7,1.1,2,1.8,2c0.2,0,0.9,0,1.7,0v0.8H6.3 c-0.9,0-1.6,0.8-1.6,1.6v25.9c0,0.9,0.7,1.6,1.6,1.6h10.5c0.9,0,1.6-0.8,1.6-1.6V19.5C18.3,18.6,17.6,17.9,16.7,17.9z M16.7,15.7 l-0.9-0.4v-1.9l0.8,0.1L16.7,15.7z M16.6,13.1h-0.8v0v-2l0.8-2.1V13.1z M7.2,15.2l-0.8,0.3v-2l0.8-0.1V15.2z M7.2,12.7H6.5V8.6 l0.8,2.1V12.7z M7.4,10L6.3,7.4c0,0,2.3-0.7,5.4-0.7c3.1,0,4.9,0.8,4.9,0.8l-1.1,2.5c0,0-1.2-0.4-4.1-0.4S7.4,10,7.4,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.83f08dd67f6b6ea79c7cc4576326c0bd.svg";
export { ForwardRef as ReactComponent };